(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('module/slides/iframe.html', '<div class=\"slide slide--bg-gradient\" ng-class=\"{\'slide--{{ slide.type }}\': slide.type}\">\n\n\n	<iframe frameborder=\"0\" width=\"100%\" height=\"100%\" ng-src=\"{{trustSrc(slide.iframe)}}\"></iframe>\n		\n\n</div>\n');
    }]);
})();